export const classColorsMap = {
    green: 'status-green',
    red: 'status-red',
    gray: 'status-gray',
    yellow: 'status-yellow',
    orange: 'status-orange',
};

